<template>
  <div id="sponsor">
    <div class="row">
      <div class="banner ban_title">
        <div><h1>赞助机会</h1></div>
      </div>
    </div>
    <div class="sponsor">
      <div class="row">
        <div class="cooper">
          <h1>合作伙伴</h1>
          <ul></ul>
        </div>
      </div>
      <div class="row why">
        <h1>为什么赞助</h1>
        <div class="wenz_all pc">
          <div class="wenz">
            1. 限额3家：本合作方案全年仅招募3家战略合作伙伴<br />
            2. 与目标客户面对面沟通：通过现场展位，与200家大中型企业客户直接沟通互动<br />
            3. 品牌推广：40家媒体合作伙伴和200家软件园区的线上线下联合推广曝光<br />
            4. 人群高端—中高级技术管理者：到场学员均在技术经理级别以上，有一定的话语权和决策权
          </div>
        </div>
        <div class="wap_wenz">
          <div class="wenz mob">
            <p>1. 限额3家：本合作方案全年仅招募3家战略合作伙伴<br /></p>
            <p>2. 与目标客户面对面沟通：通过现场展位，与200家大中型企业客户直接沟通互动<br /></p>
            <p>3. 品牌推广：40家媒体合作伙伴和200家软件园区的线上线下联合推广曝光<br /></p>
            <p>4. 人群高端—中高级技术管理者：到场学员均在技术经理级别以上，有一定的话语权和决策权</p>
          </div>
        </div>
      </div>
      <div class="hangye">
        <h1>行业客户分布<span>1500</span>家</h1>
        <p class="fugai">
          覆盖核心城市技术圈：北京、上海、深圳、福州4城联动，技术影响力辐射一线城市
        </p>
        <h1 class="pc"><span>1300</span>位中高层经理级参与学习</h1>
        <h1 class="mob"><span>1300</span>位<br />中高层经理级参与学习</h1>
        <h1 class="leibie">学员类别</h1>
        <div class="img">
          <img src="../../static/images/sponsor_chat.png" />
        </div>
        <!-- <div class="but"><a href="">下载赞助方案</a></div> -->
        <h1>合作联系人</h1>
        <div class="row hezuo pc">
          <div class="hezuoz ">
            <!-- <div class="le">
              详情咨询：赵丹丹<br />
              邮箱：dandan.zhao@msup.com.cn<br />
              联系电话：158-0221-7295
            </div> -->
            <div class="le" v-if="global.area_id >= '4886'">
              详情咨询：Reki<br />
              联系电话：138-2010-5680<br />
              邮箱：reki@msup.com.cn
              <!-- {{global.company_phone[2]}} -->
            </div>
            <div class="le" v-else>
              详情咨询：张东光<br />
              联系电话：{{global.company_phone[2]}}<br />
              邮箱：dongguang.zhang@msup.com.cn
            </div>
            <div class="ri">
              赞助合作：sissi<br />
              联系电话：{{global.company_phone[1]}}<br />
              邮箱：market@msup.com.cn
            </div>
          </div>
        </div>
        <div class="wap_hezuo mob">
          <div class="hezuoz" v-if="global.area_id >= '4886'">
            详情咨询：Reki<br />
            联系电话：138-2010-5680<br />
            邮箱：reki@msup.com.cn<br />
            赞助合作：sissi<br />
            联系电话：{{global.company_phone[1]}}<br />
            邮箱：market@msup.com.cn
          </div>
          <div class="hezuoz" v-else>
            <!-- 详情咨询：赵丹丹<br />
            邮箱：dandan.zhao@msup.com.cn<br />
            联系电话：158-0221-7295<br /> -->
            详情咨询：张东光<br />
            联系电话：{{global.company_phone[2]}}<br />
            邮箱：dongguang.zhang@msup.com.cn<br />
            赞助合作：sissi<br />
            联系电话：{{global.company_phone[1]}}<br />
            邮箱：market@msup.com.cn
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import $ from 'jquery'

export default {
  name: 'Sponsor',
  methods: {
    getSponsor: function () {
      // 获取赞助与合作
      var area_id = this.global.area_id
      var url_sponsor = this.global.url.gettype + this.global.config[area_id].adId
      // console.log("url_sponsor ", url_sponsor, ' ', area_id);
      this.getData(url_sponsor)
    },
    getData: function (url_sponsor = '') {
      $.ajax({
        type: 'get',
        url: url_sponsor,
        dataType: 'jsonp',
        success: function (obj) {
          // console.log("sponsor ", obj);
          if (obj.errno && obj.errno.toString() === '0') {
            if (obj.data && obj.data[0] && obj.data[0].length > 0) {
              for (var i = 0; i < obj.data[0].length; i++) {
                var str =
                `<li class="col-lg-3 col-md-3 col-sm-6 col-xs-6">
                  <div><img src="${obj.data[0][i].file}" /></div>
                  </li>`
                $('.cooper ul').append(str)
              }
              let ml = '<li class="col-lg-3 col-md-3 col-sm-6 col-xs-6"><div>虚位以待</div></li>'
              let clf = ' <li class="clearfloat"></li>'
              $('.cooper ul').append(ml)
              // $(".wap_zhanzhu_five").append(clf);
            }
          } else {
            console.log('请求错误')
          }
        }
      })
    }
  },
  created () {
    this.getSponsor()
  }
}
</script>

<style scoped>
/*  */
</style>



// WEBPACK FOOTER //
// src/viewsNew/Sponsor.vue